<template>
  <LayoutContent>
    <AcknowledgementCard :title="`${$t('label.seeYouSoon')}!`">
      <template #acknowledgement-body>
        <v-container class="px-sm-16">
          <v-row>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.bookingNo') }}
              </p>
              <p class="font-weight-medium">{{ bookingInfo.booking_number }}</p>
            </v-col>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.dateAndTime') }}
              </p>
              <p class="font-weight-medium">
                <span class="mr-4">{{ bookingInfo.date | shortDate }}</span>
                <span>{{ bookingInfo.time | shortTime }}</span>
              </p>
            </v-col>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.salon') }}
              </p>
              <p class="font-weight-medium">{{ bookingInfo.store }}</p>
            </v-col>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.hairStylist') }}
              </p>
              <p class="font-weight-medium">{{ bookingInfo.stylist }}</p>
            </v-col>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.services') }}
              </p>
              <p class="font-weight-medium" v-for="(service, i) in bookingInfo.services" :key="i">{{ i + 1 }}. {{ service }}</p>
            </v-col>
          </v-row>
          <v-divider class="my-4" />
          <p class="font-weight-medium mb-8">{{ bookingInfo.remarks }}</p>
        </v-container>
      </template>
      <template #contact>
        <div class="mb-8">
          <p class="secondary--text text--lighten-1 font-weight-medium text-caption text-center">{{ $t('label.contactUs') }}:</p>
          <p class="secondary--text text--lighten-1 font-weight-medium text-caption text-center">{{ bookingInfo.store_contactno }}</p>
          <a class="font-weight-medium text-caption text-center pa-0" :href="`mailto:${bookingInfo.store_email}`">{{ bookingInfo.store_email }}</a>
        </div>
      </template>
    </AcknowledgementCard>
  </LayoutContent>
</template>

<script>
import { mapState } from 'vuex'

import LayoutContent from '@/views/layouts/LayoutContent.vue'
import AcknowledgementCard from '@/components/AcknowledgementCard.vue'

export default {
  name: 'MakeAppointmentComplete',
  components: {
    LayoutContent,
    AcknowledgementCard
  },

  computed: {
    ...mapState('appointment', ['bookingInfo'])
  },

  created() {
    if (!this.bookingInfo.booking_number) {
      this.$router.push('/')
    }
  }
}
</script>
